import { validatePhoneNumberLength } from 'libphonenumber-js';
import metadata from 'libphonenumber-js/metadata.max.json';

const callingCodes = Object.keys(metadata.country_calling_codes);

export const isOnlyCallingCodeEntered = (value: string) => {
  return callingCodes.includes(value.replace(/\D/g, ''));
};

export const isValidPhoneHelper = (phone: string) => {
  if (isOnlyCallingCodeEntered(phone)) {
    return true;
  }

  return !validatePhoneNumberLength(phone);
};
